<template>
    <div class="align-items-end">
        <!-- Footer -->
        <footer class="text-center text-lg-start text-white bg-dark">
            <!-- Grid container -->
            <div class="container p-4 pb-0">
                <!-- Section: Links -->
                <section class="">
                    <!--Grid row-->
                    <div class="row">
                        <!-- Grid column -->
                        <div class="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
                            <h6 class="text-uppercase mb-4 font-weight-bold">
                                Beau Voyage
                            </h6>
                            <p class="textoFooter">
                                Aprovecha nuestras increíbles ofertas en paquetes de viaje a Europa, Turquía y
                                Sudamérica.
                                Incluyen visitas indicadas en el itinerario, alojamiento y desayunos. Viaja acompañado y
                                disfruta de destinos fascinantes con esta promoción especial. ¡Solicita tu asesoría!
                            </p>
                        </div>
                        <!-- Grid column -->



                        <!-- Grid column -->
                        <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
                            <h6 class="text-uppercase mb-4 font-weight-bold">Método de pago</h6>
                            <p>
                                <a class="text-white" @click="metodosFooter()" href="#">Ver metodos de pago</a>
                            </p>
                        </div>
                        <!-- Grid column -->



                        <!-- Grid column -->
                        <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
                            <h6 class="text-uppercase mb-4 font-weight-bold">
                                Navegación
                            </h6>
                            <p>
                                <a href="/" class="text-white">Ofertas</a>
                            </p>
                            <p>
                                <a href="/Paquetes" class="text-white">Paquetes</a>
                            </p>
                            <p>
                                <a class="text-white">Translados</a>
                            </p>
                            <p>
                                <a class="text-white">Hoteles</a>
                            </p>
                            <p>
                                <a href="/Asesorias" class="text-white">Asesoría</a>
                            </p>
                        </div>

                        <!-- Grid column -->


                        <!-- Grid column -->
                        <div class="col-md-4 col-lg-3 col-xl-3 mx-auto mt-3">
                            <h6 class="text-uppercase mb-4 font-weight-bold">Contacto</h6>
                            <p style="font-size: 12px"><i class="fas fa-envelope mr-3"></i>
                                ventas@beauvoyage.net</p>
                            <p style="font-size: 12px"><i class="fas fa-phone mr-3"></i> + 52 55 4540 1703</p>
                        </div>
                        <!-- Grid column -->
                    </div>
                    <!--Grid row-->
                </section>
                <!-- Section: Links -->

                <hr class="my-3">

                <!-- Section: Copyright -->
                <section class="p-3 pt-0">
                    <div class="row d-flex align-items-center">
                        <!-- Grid column -->
                        <div class="col-md-7 col-lg-8 text-center text-md-start">
                            <!-- Copyright -->
                            <div class="p-3">
                                © 2025 Copyright:
                                <a class="text-white" href="">BeauVoyage.net</a>
                            </div>
                            <!-- Copyright -->
                        </div>
                        <!-- Grid column -->

                        <!-- Grid column -->
                        <div class="col-md-5 col-lg-4 ml-lg-0 text-center text-md-end">
                            <!-- Facebook -->
                            <a class="btn btn-outline-light btn-floating m-1 text-white" role="button"
                                href="https://www.facebook.com/share/17TfNUmF6v/"><i
                                    class="fab fa-facebook-f"></i></a>


                            <a class="btn btn-outline-light btn-floating m-1 text-white" role="button"
                                href="https://www.tiktok.com/@beau.voyage.agencia?_t=ZS-90de9UePT9k&_r=1"><i
                                    class="fab fa-tiktok"></i></a>



                            <!-- Instagram -->
                            <a class="btn btn-outline-light btn-floating m-1 text-white" role="button"
                                href="https://www.instagram.com/beauvoyageagencia"><i class="fab fa-instagram"></i></a>
                        </div>
                        <!-- Grid column -->
                    </div>
                </section>
                <!-- Section: Copyright -->
            </div>
            <!-- Grid container -->
        </footer>
        <!-- Footer -->
    </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
    name: "FooterWeb",
    methods: {
        metodosFooter() {
            Swal.fire({
                title: "¡Metodos de pago!",
                html: `
        <div class='row justify-content-md-center'>
        <div class='col-12 col-md-6 mb-3'><img src="1.png" style="width: 100%; height: auto;"></div>
        <div class='col-12 col-md-6 mb-3'><img src="2.png" style="width: 100%; height: auto;"></div>
        <div class='col-12 col-md-6 mb-3'><img src="3.png" style="width: 100%; height: auto;"></div>
        </div>
      `,
                width: "100%",
                showCancelButton: true,

                cancelButtonText: "Enviar comprobante WhatsApp",

            }).then((result) => {
                if (
                    result.dismiss === Swal.DismissReason.cancel
                ) {
                    // Redirigir al chat de WhatsApp
                    window.open(
                        "https://wa.me/1234567890?text=¡Hola!%20Me%20gustaría%20saber%20más.",
                        "_blank"
                    );
                }
            });
        }
    }
}
</script>